import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { MyJobStatuses } from './models/job-statuses';
import { JobsStore } from './store/jobs-store.service';

@Injectable({
  providedIn: 'root',
})
export class JobResolverService implements Resolve<any> {
  constructor(private jobsStore: JobsStore) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.jobsStore.getMyJobs(MyJobStatuses.Applied, 1);
  }
}
